export const PermissionValues = {
    refunds: {
        view: 'view_refund',
        initiateRefund: 'refund',
    },
    settlements: {
        view: 'view_settlements',
    },
    transactions: {
        view: 'view_transactions',
    },
    paymentAnalytics: {
        view: 'view_payment_analytics',
    },
    paymentLinks: {
        view: 'view_payment_links',
        create: 'create_payment_links'
    },
}

export const MerchantConfigKeys = {
    paymentAnalytics: {
        view: 'show_payment_analytics_v2',
        selectedCharts: 'selected_payment_v2_charts',
    },
    paymentConfigsEnabled: 'payment_configs_enabled',
}

export enum PaymentLinkModeEnum {
    UPI_DEEPLINK = 'upi-deeplink',
    STANDARD = 'standard',
}
export const PaymentProviders = {
    SNAPMINT: 'snapmint',
    BILLDESK: 'billdesk',
    BHARATX: 'bharatx',
    CREDPAY: 'credpay',
    EASEBUZZ: 'easebuzz',
    PAYU: 'payu',
    TWID: 'twid',
    QWIKCILVER: 'qwik_cilver',
    GYFTR: 'gyftr',
    NECTOR: 'nector',
    SIMPL: 'simpl'
}

export const RewardRedemptions = {
    EARN: 'earn',
    BURN: 'burn'
}

export const PaymentMethods = {
    CREDIT_CARD: 'credit_card',
    DEBIT_CARD: 'debit_card',
    UPI: 'upi',
}

export const SuccessStatusCodes = [201, 200]

export const INPUT_TYPES = {
    TOGGLE: 'toggle',
    SELECT: 'select',
    TEXT: 'text',
}

export const PaymentMethodsBgPositions = {
    upi: '0px 0px',
    cards: '-28px 0px',
    wallets: '-55px 0px',
    netbanking: '-82px 0px',
    paylater: '-109px 0px',
    cod: '-136px 0px',
};

export const InstrumentNameMapping = {
    'bnpl-gk': 'Gokwik Bnpl',
    'bnpl-lazypay': 'Lazypay',
    'bnpl-tatapay': 'TataPay',
    'wallet-bajajpay': 'Bajaj Pay',
    'bnpl-amazonpay': 'Amazon Pay Later',
    'wallet-airtelmoney': 'Airtel Money',
    'wallet-amazonpay': 'Amazon Pay',
    'wallet-hdfcpayzapp': 'Hdfc Pay Zapp',
    'wallet-itzcash': 'Itzcash',
    'wallet-jiomoney': 'Jio Money',
    'wallet-mobikwik': 'Mobikwik',
    'wallet-paytm': 'Paytm',
    'wallet-phonepe': 'Phonepe',
    'wallet-yesbank': 'Yes Bank',
    'wallet-freecharge': 'Freecharge',
    'wallet-olamoney': 'Ola Money',
    'wallet-oxigen': 'Oxigen',
    'emi-bajajf': 'Bajaj Finserv EMI',
    'emi-zestmoney': 'ZestMoney EMI',
    'emi-cc': 'Credit Card EMI',
    'emi-dc': 'Debit Card EMI',
    'simplpayin3': 'Simpl Pay In 3',
    'bnpl-simplpay': 'Simpl Pay Later'
}

export const PAYMENT_METHODS = {
    UPI: 'upi',
    CARDS: 'cards',
    WALLETS: 'wallets',
    WALLET: 'wallet',
    NETBANKING: 'netbanking',
    PAYLATER: 'paylater',
    COD: 'cod',
    SIMPLPAYIN3: 'simplpayin3',
    PAY_IN_X: 'pay_in_x',
    PPCOD_UPI: 'ppcod-upi',
    PPCOD: 'ppcod',
    NATIVE: 'native',
    BNPL: 'bnpl',
    GOKWIK_BNPL: 'bnpl-gk',
    EMI: 'emi',
    BHARATX: 'bharatx',
    BHARATX_PAY: 'bharatxpay',
    SNAPMINT: 'snapmint',
}

export const Platforms = {
    CHECKOUT_1_0_SHOPIFY: 'checkout_1_0_shopify',
    CORE: 'core',
    GKP: 'gkp',
    SHOPIFY_PAYMENTS_APP: 'shopify_payments_app',
}